export const GroupItemMockData = {
  id: '1acf7c64-2228-ec11-981f-000d3a223e22',
  name: 'Mock Group',
  members: [
    {
      memberId: 'be2bb946-b237-ec11-981f-000d3a223db3',
      name: 'mockgroupitem@gmail.com',
    },
  ],
  organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
  organization: 'Mock Group Organization',
};
